import type { Node } from 'react'
import React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { TileSquare } from 'app/common/tile-square'
import { media } from 'app/assets/styles'
import FlipMove from 'react-flip-move'
import type { EventMetadata } from 'shared/store/metadata'

type Props = {
    tiles: Array<{
        actionUrl?: string,
        image: Array<string>,
        name: string,
        price?: number,
        backgroundColor?: string,
        color?: string,
        meta?: Array<EventMetadata> | EventMetadata,
        iconTop?: Node,
        iconBottom?: Node,
        type?: string
    }>,
    justify?: string,
    margin?: string,
    hasTileText?: boolean,
    className?: string,
    isCategories?: boolean
}

const TileSquareGrid = (props: Props) => {
    const {
        tiles,
        justify,
        margin,
        hasTileText,
        className,
        isCategories = false
    } = props

    const tilesList = tiles.map((tile, index) => {
        const { price } = tile
        const priceNode = price && (
            <FormattedMessage id="price.currency" values={{ price: price }} />
        )

        return (
            <Column className={className} key={index} hasTileText={hasTileText}>
                <TileSquare
                    {...tile}
                    margin={margin}
                    priceNode={priceNode}
                    index={index}
                    hasTileText={hasTileText}
                    isCategory={isCategories}
                />
            </Column>
        )
    })

    return (
        <List justify={justify} className={className}>
            <FlipMove
                staggerDelayBy={50}
                appearAnimation="fade"
                enterAnimation="fade"
                leaveAnimation="fade"
                duration={300}
                typeName={null}>
                {tilesList}
            </FlipMove>
        </List>
    )
}

const List = styled.section`
    position: relative;
    display: flex;
    flex-flow: row wrap;
    ${media.large`
        justify-content: ${props => (props.justify ? props.justify : 'center')};
    `};
    &.transformation-points {
        justify-content: center;
    }
`

const Column = styled.div`
    box-sizing: border-box;
    width: 50%;
    padding-bottom: ${props => (props.hasTileText ? `70%` : `50%`)};
    position: relative;
    ${media.small`
        width: 33%; 
        padding-bottom: 33%; 
        &.home-tiles { 
            width: 25%; 
            padding-bottom: 25%; 
        }
    `};
`

export { TileSquareGrid }
